










import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import ScheduleListSection from '../ScheduleListSection.vue'
import ScheduleDetailSection from '../ScheduleDetailSection.vue'
import AdhocSection from '../AdhocSection.vue'
import ViewPolicyPlaceHolderSection from '@core/pages/new-business-register/components/policy/ViewPolicyPlaceHolderSection.vue'
import { ScheduleTimeDto, ScheduleTimeResponseDto } from '../api'
import { SharedVariable } from '@core/model/SharedVariable'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { IDateService } from '@master/services/IDateService'
import { ScheduleTime } from '../model/ScheduleTime'

const scheduleStore = namespace('ScheduleStore')

@Component({
  components: {
    ScheduleListSection,
    ScheduleDetailSection,
    ViewPolicyPlaceHolderSection,
    AdhocSection
  }
})
export default class SchedulerPage extends Vue {
  @scheduleStore.State
  scheduleInView: ScheduleTimeDto

  @scheduleStore.State
  private scheduleList: ScheduleTimeDto[]

  @scheduleStore.Action
  private selectedScheduleInView

  @scheduleStore.Action
  private saveSchedule

  @scheduleStore.Action
  private retrieveSchedules

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  protected dateService: IDateService

  protected scheduleToEdit: ScheduleTime = null

  get frequencyOptions () {
    return [
      {
        label: 'Daily',
        value: 3
      },
      {
        label: 'Weekdays',
        value: 4
      },
      {
        label: 'Weekly',
        value: 0
      },
      {
        label: 'Bi-Weekly',
        value: 1
      },
      {
        label: 'Monthly',
        value: 2
      }
    ]
  }

  async viewScheduleDetails (schedule: ScheduleTimeResponseDto) {
    const originalSchedule = this.scheduleList.find(schedule => schedule.name === this.scheduleToEdit?.name)
    if (this.scheduleToEdit && this.scheduleToEdit.compareDifferences(originalSchedule)) {
      const decision = await this.uiService.confirm.show({
        type: 'warning',
        message: 'There are unsaved changes, do you want to leave?'
      })

      if (!decision) {
        return
      }
    }
    this.selectedScheduleInView(schedule)
    this.scheduleToEdit = ScheduleTime.cloneSchedule(schedule)
  }

  async updateSchedule (scheduleToUpdate: ScheduleTimeDto) {
    const result = await this.saveSchedule(scheduleToUpdate)
    if (result) {
      this.uiService.alert.show({
        type: 'success',
        message: 'Updated Task\'s Schedule.'
      })
      await this.retrieveSchedules()
    }
  }

  get displayAdhocSection () {
    if (this.scheduleInView !== null) {
      return this.scheduleInView.name === ScheduleTimeDto.name.PRESALES_CALLBACK || this.scheduleInView.name === ScheduleTimeDto.name.CLIENT_NAME_SCREENING
    }

    return false
  }

  async mounted () {
    this.uiService = this.sharedVariable.uiService
    await this.retrieveSchedules()
  }

  get schedulerNiceNames () {
    return {
      COMMISSION_REPORT: 'Commission Report Schedule Task',
      CLIENT_NAME_SCREENING: 'Individual Customer Name Screening Task',
      ADVISER_NAME_SCREENING: 'Adviser Name Screening Task',
      CORPORATE_NAME_SCREENING: 'Corporate Customer Name Screening Task',
      PRESALES_CALLBACK: 'Presales Callback Task',
      MARKETING_CONSENT: 'Marketing Consent Task'
    }
  }
}
